import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AppsService, IntegrationVoteData } from '../../../../shared/services/apps/apps.service';
import { DialogUpvoteComponent } from '../../components/dialog-upvote/dialog-upvote.component';

@Component({
  standalone: false,
  selector: 'sbnb-upvote',
  templateUrl: './upvote.component.html',
  styleUrls: ['./upvote.component.scss'],
})
export class UpvoteComponent implements OnInit {
  integrations: IntegrationVoteData[];
  isLoading = true;
  constructor(
    private appsService: AppsService,
    private dialog: MatDialog
  ) { }

  suggestIdea() {
    window.open('https://feedback.hospitable.com/boards/feature-requests-board', 'suggest');
  }

  upvote(integration: IntegrationVoteData) {
    if (!integration.has_voted) {
      const dialogRef = this.dialog.open(DialogUpvoteComponent, {
        width: '720px',
        maxHeight: '90vh',
        data: integration,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          const integration = this.integrations.find((i) => i.id === result.id);
          integration.has_voted = true;
          integration.votes++;
          this.appsService.upvoteIntegration(result.id, result.comment).subscribe((res) => {
            if (res.error) {
              integration.has_voted = false;
              integration.votes--;
            }
          });
        }
      });
    }
  }

  ngOnInit() {
    this.appsService.getIntegrations().subscribe((res) => {
      this.isLoading = false;
      this.integrations = res.integrations;
    });
  }
}
